import BaseApi from '@lumapps/base-api';

export const bookmarksApi = new BaseApi({ path: 'bookmarks' });

export const getBookmarks = () => {
    return bookmarksApi.get('get');
};
